import { render, staticRenderFns } from "./CardUsuario.vue?vue&type=template&id=11250e60&scoped=true&"
import script from "./CardUsuario.vue?vue&type=script&lang=js&"
export * from "./CardUsuario.vue?vue&type=script&lang=js&"
import style0 from "./CardUsuario.vue?vue&type=style&index=0&id=11250e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11250e60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
